import { Link, animateScroll as scroll } from 'react-scroll'


function Footer() {


  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="side1">
            <div className="row">
              <div className="col-md-3">
                <h1 className="logo">Hospihands</h1>
                <p className="footer-text">
                  © 2023 Hospihands Private Limited
        
                </p>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Important Links</p>
                <ul>
                  <li>
                  <Link   
                         spy={true}
                         smooth={true}
                         duration={1000}
                         to="headerbg"
                  > Home </Link>
                  </li>
                  <li>
                  <Link to="services" spy={true} smooth={true} duration={1000} >Our Solutions</Link>
                  </li>
                  <li>
                  <Link to="about-scroll" spy={true} smooth={true} duration={1000}>About Us</Link>
                  </li>
                  <li>
                  <Link to="contact" spy={true} smooth={true} duration={1000}>Contact</Link>
                  </li>
                  <li>
                  <a href="https://console.hospihands.com/server/static/terms.html">Terms and Conditions</a>
                  </li>
                  <li>
                  <a href="https://console.hospihands.com/server/static/privacy.html">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="side2">
            <div className="row">
              <div className="col-md-3">
                <p className="footer-title">Contact</p>
                <ul>
                  <li>
                    <Link to="#" >connect@hospihands.com</Link>
                  </li>
                  <li>
                    <Link to="#" >Ghaziabad, Uttar Pradesh, India</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Social Media</p>
                <ul>
                  <li>
                    <a target="_blank" rel="noreferrer" href="" > Instagram</a>
                  </li>
                  <li>
                    <a target="_blank" rel="noreferrer" href="" > Twitter</a>
                  </li>
                  <li>
                    <a target="_blank" rel="noreferrer" href=""> Linkedin</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button onClick={() => scroll.scrollToTop(2500)} src="" className="gotop"><i className="fas fa-level-up-alt"></i></button>

    </footer>
  );
}
export default Footer;
